import React from 'react';
import { BaseComponent } from "../../../../project/general";
import { render } from "preact";
import { ToggleButton } from "../../toggle-button"
class TimelineYearComponent extends BaseComponent {
    static getNamespace() {
        return 'timeline-year';
    }

    static getRequiredRefs() {
        return ["yearProgress", "carouselNavLabel", "backgroundTogglePlaceholder"];
    }

    items = [];
    currentIndex = 0;

    carousel = null;
    carouselItem = null;
    carouselItemImg = null;
    carouselItemHeading = null;
    carouselItemContent = null;
    carouselItemLink = null;
    decadeMsg = null;
    decadeMsgParagraph = null;
    decadeButtons = null;
    prevButton = null;
    nextButton = null;
    background = null;
    decadeSelect = null;
    selectedItem = null;

    cacheDomElements() {
        this.carousel = document.querySelector(".carousel");
        this.carouselItem = this.carousel.querySelector(".carousel-item");
        this.carouselItemHeading = this.carouselItem.querySelector("h2");
        this.carouselItemContent = this.carouselItem.querySelector("div.heritage-paragraph");
        this.carouselItemLink = this.carouselItem.querySelector("a.primary-button");
        this.carouselItemImg = document.querySelector("#carouselItemImg");
        this.decadeMsg = document.querySelector(".decade-message");
        this.decadeMsgParagraph = this.decadeMsg?.querySelector("p");
        this.decadeButtons = document.querySelectorAll(".decade-button");
        this.prevButton = document.querySelector("#prev");
        this.nextButton = document.querySelector("#next");
        this.background = document.querySelector("#ah-background-image");
        this.decadeSelect = document.querySelector(".ah-decade-select select");
    }

    bindEventListeners() {
        if (this.prevButton) {
            this.prevButton.addEventListener("click", () => this.showPreviousItem());
        }

        if (this.nextButton) {
            this.nextButton.addEventListener("click", () => this.showNextItem());
        }

        this.decadeButtons?.forEach(button => {
            button.addEventListener("click", (event) => {
                const itemId = event.target.getAttribute("data-item-id");
                this.updateCarousel(itemId);
                this.setActiveDecadeButton(event.target);
            });
        });

        if (this.decadeSelect) {
            this.decadeSelect.addEventListener("change", (event) => {
                const selectedOption = event.target.selectedOptions[0];
                const itemId = selectedOption.getAttribute("data-item-id");

                this.updateCarousel(itemId);

                const matchingButton = [...this.decadeButtons].find(btn =>
                    btn.getAttribute("data-item-id") === itemId
                );
                if (matchingButton) {
                    this.setActiveDecadeButton(matchingButton);
                }
            });
        }
    }

    setActiveDecadeButton(activeButton) {
        this.decadeButtons?.forEach(btn => btn.classList.remove("active"));
        activeButton.classList.add("active");
    }

    updateCarousel(itemId) {
        baseApi
            .get(`/api/TimelineItemsApi/GetTimelineItemsForDecade?decadeId=${itemId}`)
            .then((res) => {
                if (!res.data || !res.data.success) return;

                this.items = res.data.data || [];
                this.currentIndex = 0;

                if (!this.items.length) {
                    this.toggleVisibility(false);
                    return;
                }

                this.showItem(this.currentIndex);
                this.toggleVisibility(true);

                if (res.data.message) {
                    this.decadeMsgParagraph.textContent = res.data.message;
                    this.decadeMsg.classList.remove("hidden");
                } else {
                    this.decadeMsgParagraph.textContent = "";
                    this.decadeMsg.classList.add("hidden");
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    toggleVisibility(show) {
        if (show) {
            this.carousel.classList.remove("hidden");
            this.carouselItemImg.classList.remove("hidden");
        } else {
            this.carousel.classList.add("hidden");
            this.carouselItemImg.classList.add("hidden");
        }
    }

    /* Background image toggling */
    renderToggleButton = () => {
        var trueText = this.refs.backgroundTogglePlaceholder.dataset.trueText;
        var falseText = this.refs.backgroundTogglePlaceholder.dataset.falseText;
        render(
            <ToggleButton value={this.backgroundImageIsVisible()}
                onToggle={this.toggleShowBackgroundImage}
                trueText={trueText}
                falseText={falseText}>
            </ToggleButton>,
            this.refs.backgroundTogglePlaceholder
        );
    }

    backgroundImageIsVisible = () => {
        return (localStorage.getItem("showBackgroundImage") == "true");
    }

    toggleShowBackgroundImage = () => {
        var value = !this.backgroundImageIsVisible();
        localStorage.setItem("showBackgroundImage", value);
        this.showOrHideBackgroundImage();
        return value;
    }

    showOrHideBackgroundImage() {
        if (this.selectedItem.hasBackgroundImage && this.backgroundImageIsVisible()) {
            this.background.style.backgroundImage = `url(${this.selectedItem.backgroundImageUrl})`;
        } else {
            this.background.style.backgroundImage = 'none';
        }
    }
    /* End background image toggling */

    showItem(index) {
        if (this.items.length <= index) return;

        this.selectedItem = this.items[index];

        this.refs.yearProgress.style.width = this.selectedItem.timelinePosition + "%";
        this.refs.carouselNavLabel.innerHTML = (index + 1) + "/" + this.items.length;

        this.carouselItem.style.opacity = "0";
        this.carouselItem.style.transition = "opacity 0.5s ease";

        this.carouselItemHeading.textContent = this.selectedItem.title;
        this.carouselItemContent.innerHTML = this.selectedItem.mainContent;

        if (this.selectedItem.hasLinkUrl) {
            this.carouselItemLink.setAttribute("href", this.selectedItem.linkUrl);
            this.carouselItemLink.classList.remove("hidden");
        } else {
            this.carouselItemLink.setAttribute("href", "#");
            this.carouselItemLink.classList.add("hidden");
        }

        if (this.selectedItem.hasMainImage) {
            this.carouselItemImg.setAttribute("src", this.selectedItem.mainImageUrl);
            this.carouselItemImg.setAttribute("alt", this.selectedItem.mainImageAltText);
            this.carouselItemImg.classList.remove("hidden");
        } else {
            this.carouselItemImg.removeAttribute("src");
            this.carouselItemImg.removeAttribute("alt");
            this.carouselItemImg.classList.add("hidden");
        }

        if (this.selectedItem.hasBackgroundImage && this.backgroundImageIsVisible()) {
            this.background.style.backgroundImage = `url(${this.selectedItem.backgroundImageUrl})`;
        } else {
            this.background.style.backgroundImage = 'none';
        }

        setTimeout(() => {
            this.carouselItem.style.opacity = "1";
            this.carousel.style.height = `${this.carouselItem.offsetHeight}px`;
        }, 10);
    }

    showNextItem() {
        if (!this.items.length) return;
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        this.showItem(this.currentIndex);
    }

    showPreviousItem() {
        if (!this.items.length) return;
        this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
        this.showItem(this.currentIndex);
    }

    onScript() {
        this.cacheDomElements();
        this.bindEventListeners();

        const params = new URLSearchParams(document.location.search);
        const requestedDecade = params.get("decade");

        let initDecadeBtn = [...this.decadeButtons].find(btn =>
            btn.getAttribute("data-item-decade") === requestedDecade
        ) || this.decadeButtons[0];

        if (initDecadeBtn) {
            const initItemId = initDecadeBtn.getAttribute("data-item-id");
            this.updateCarousel(initItemId);
            this.setActiveDecadeButton(initDecadeBtn);

            [...this.decadeSelect.options].forEach(option => {
                option.selected = option.getAttribute("data-item-id") === initItemId;
            });


        }

        if (this.carouselItem) {
            this.carouselItem.style.width = "100%";
        }

        this.renderToggleButton();

    }

    onInit() {
       this.onScript();
    }
}

export default TimelineYearComponent;


